import { Box, Button, Card, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { SentIcon } from 'src/components/sent-icon/sentIcon';
import ResetPasswordForm from './resetPasswordForm';

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

export default function ResetPassword() {
  const { t: translate } = useTranslation();

  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  return (
    <div title="Reset Password" sx={{ height: 1 }}>
      <RootStyle>
        <Container>
          <Box sx={{ maxWidth: 480, mx: 'auto' }}>
            <Card sx={{ py: 3, px: 3, textAlign: 'center' }}>
              {!sent ? (
                <>
                  <Typography variant="h3" paragraph>
                    {translate('reset_password.forgot_password')}
                  </Typography>
                  <Typography sx={{ color: 'text.secondary', mb: 5 }}>
                    {translate('reset_password.reset_password_msg')}
                  </Typography>

                  <ResetPasswordForm onSent={() => setSent(true)} onGetEmail={(value) => setEmail(value)} />

                  <Button fullWidth size="large" variant="outlined" component={RouterLink} to={'/'} sx={{ mt: 3 }}>
                    {translate('reset_password.back')}
                  </Button>
                </>
              ) : (
                <Box sx={{ textAlign: 'center' }}>
                  <SentIcon sx={{ mb: 5, mx: 'auto', height: 160 }} />

                  <Typography variant="h3" gutterBottom>
                    {translate('reset_password.request_send_successfully')}
                  </Typography>
                  <Typography>
                    {translate('reset_password.send_confirmation_email')} &nbsp;
                    <strong>{email}</strong>
                    <br />
                    {translate('reset_password.check_email')}
                  </Typography>

                  <Button size="large" variant="contained" component={RouterLink} to={'/'} sx={{ mt: 5 }}>
                    {translate('reset_password.back')}
                  </Button>
                </Box>
              )}
            </Card>
          </Box>
        </Container>
      </RootStyle>
    </div>
  );
}
